var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDelete, useNotify, useRedirect, useUpdate } from "react-admin";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import InventoryIcon from "@mui/icons-material/Inventory";
import { Divider, ListItemIcon, MenuItem, MenuList, Popover } from "@mui/material";
import { Dialog, adminTheme } from "@sequentech/ui-essentials";
import { getNavLinkCreate, mapAddResource, mapImportResource } from "./TreeMenu";
import { useActionPermissions, useTreeMenuData } from "../use-tree-menu-hook";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import { divContainer } from "@/components/styles/Menu";
import { useMutation } from "@apollo/client";
import { DELETE_ELECTION_EVENT } from "@/queries/DeleteElectionEvent";
import { IPermissions } from "@/types/keycloak";
import { useElectionEventTallyStore } from "@/providers/ElectionEventTallyProvider";
import { useCreateElectionEventStore } from "@/providers/CreateElectionEventContextProvider";
import { useWidgetStore } from "@/providers/WidgetsContextProvider";
import { ETasksExecution } from "@/types/tasksExecution";
import { getMenuActionConfirmMessage } from "./menuActionConfirmMessage";
var mapRemoveResource = {
    sequent_backend_election_event: "sideMenu.menuActions.remove.electionEvent",
    sequent_backend_election: "sideMenu.menuActions.remove.election",
    sequent_backend_contest: "sideMenu.menuActions.remove.contest",
    sequent_backend_candidate: "sideMenu.menuActions.remove.candidate",
};
var Action;
(function (Action) {
    Action[Action["Add"] = 0] = "Add";
    Action[Action["Import"] = 1] = "Import";
    Action[Action["Remove"] = 2] = "Remove";
    Action[Action["Archive"] = 3] = "Archive";
    Action[Action["Unarchive"] = 4] = "Unarchive";
})(Action || (Action = {}));
var StyledIconContainer = styled("p")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    cursor: pointer\n"], ["\n    ", "\n    cursor: pointer\n"])), divContainer);
var StyledAddCircleIcon = styled(AddCircleIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n"], ["\n    color: ", ";\n"])), adminTheme.palette.brandColor);
export default function MenuAction(_a) {
    var _this = this;
    var isArchivedTab = _a.isArchivedTab, resourceId = _a.resourceId, resourceName = _a.resourceName, resourceType = _a.resourceType, parentData = _a.parentData, menuItemRef = _a.menuItemRef, setAnchorEl = _a.setAnchorEl, anchorEl = _a.anchorEl, reloadTree = _a.reloadTree;
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    var navigate = useNavigate();
    var redirect = useRedirect();
    var deleteOne = useDelete()[0];
    var update = useUpdate()[0];
    var delete_election_event = useMutation(DELETE_ELECTION_EVENT, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.ELECTION_EVENT_DELETE,
            },
        },
    })[0];
    var notify = useNotify();
    var refetch = useTreeMenuData(isArchivedTab).refetch;
    var _c = React.useState(false), openArchiveModal = _c[0], setOpenArchiveModal = _c[1];
    var _d = React.useState(false), openDeleteModal = _d[0], setOpenDeleteModal = _d[1];
    var _e = React.useState(null), selectedActionModal = _e[0], setSelectedActionModal = _e[1];
    var _f = useWidgetStore(), addWidget = _f[0], setWidgetTaskId = _f[1], updateWidgetFail = _f[2];
    var isItemElectionEventType = resourceType === "sequent_backend_election_event";
    var _g = useElectionEventTallyStore(), setElectionEventIdFlag = _g.setElectionEventIdFlag, setElectionIdFlag = _g.setElectionIdFlag, setContestIdFlag = _g.setContestIdFlag, setCandidateIdFlag = _g.setCandidateIdFlag;
    function handleOpenItemActions() {
        setAnchorEl(menuItemRef.current);
    }
    function handleAction(action, payload) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // close the popover
                setAnchorEl(null);
                if (action === Action.Add) {
                    navigate(getNavLinkCreate(parentData, payload.type));
                }
                else if (payload.type === "sequent_backend_election_event" &&
                    (action === Action.Archive || action === Action.Unarchive)) {
                    setSelectedActionModal({ action: action, payload: payload });
                    setOpenArchiveModal(true);
                }
                else if (action === Action.Remove) {
                    setSelectedActionModal({ action: action, payload: payload });
                    setOpenDeleteModal(true);
                }
                return [2 /*return*/];
            });
        });
    }
    function handleCloseActionMenu() {
        setAnchorEl(null);
    }
    function confirmArchiveAction() {
        return __awaiter(this, void 0, void 0, function () {
            var action, payload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!selectedActionModal) {
                            return [2 /*return*/];
                        }
                        action = selectedActionModal.action, payload = selectedActionModal.payload;
                        if (!(action === Action.Archive)) return [3 /*break*/, 1];
                        update(payload.type, {
                            id: payload.id,
                            data: { is_archived: true },
                            previousData: { is_archived: false },
                        }, {
                            onSuccess: function () {
                                refetch();
                                notify(t("sideMenu.menuActions.messages.notification.success.archive"), {
                                    type: "success",
                                });
                            },
                            onError: function () {
                                notify(t("sideMenu.menuActions.messages.notification.error.archive"), {
                                    type: "error",
                                });
                            },
                        });
                        return [3 /*break*/, 3];
                    case 1:
                        if (!(action === Action.Unarchive)) return [3 /*break*/, 3];
                        return [4 /*yield*/, update(payload.type, {
                                id: payload.id,
                                data: { is_archived: false },
                                previousData: { is_archived: true },
                            }, {
                                onSuccess: function () {
                                    refetch();
                                    notify(t("sideMenu.menuActions.messages.notification.success.unarchive"), {
                                        type: "success",
                                    });
                                },
                                onError: function () {
                                    notify(t("sideMenu.menuActions.messages.notification.error.unarchive"), {
                                        type: "error",
                                    });
                                },
                            })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    var deleteElectionEventAction = function (payload) { return __awaiter(_this, void 0, void 0, function () {
        var currWidget, _a, data, errors, taskId, error_1;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    currWidget = addWidget(ETasksExecution.DELETE_ELECTION_EVENT, undefined);
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, delete_election_event({
                            variables: {
                                electionEventId: payload.id,
                            },
                        })];
                case 2:
                    _a = _e.sent(), data = _a.data, errors = _a.errors;
                    if (((_b = data === null || data === void 0 ? void 0 : data.delete_election_event) === null || _b === void 0 ? void 0 : _b.error_msg) || errors) {
                        updateWidgetFail(currWidget.identifier);
                        return [2 /*return*/];
                    }
                    taskId = (_d = (_c = data === null || data === void 0 ? void 0 : data.delete_election_event) === null || _c === void 0 ? void 0 : _c.task_execution) === null || _d === void 0 ? void 0 : _d.id;
                    setWidgetTaskId(currWidget.identifier, taskId, function () {
                        setSelectedActionModal(null);
                        setElectionEventIdFlag(null);
                        setElectionIdFlag(null);
                        setContestIdFlag(null);
                        reloadTree();
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _e.sent();
                    updateWidgetFail(currWidget.identifier);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    function confirmDeleteAction() {
        return __awaiter(this, void 0, void 0, function () {
            var payload;
            var _a;
            return __generator(this, function (_b) {
                payload = (_a = selectedActionModal === null || selectedActionModal === void 0 ? void 0 : selectedActionModal.payload) !== null && _a !== void 0 ? _a : null;
                if (!payload) {
                    return [2 /*return*/];
                }
                if (payload.type === "sequent_backend_election_event") {
                    deleteElectionEventAction(payload);
                }
                else {
                    deleteOne(payload.type, { id: payload.id }, {
                        onSuccess: function () {
                            reloadTree();
                            refetch();
                            notify(t("sideMenu.menuActions.messages.notification.success.delete"), {
                                type: "success",
                            });
                            if ((parentData === null || parentData === void 0 ? void 0 : parentData.__typename) === "sequent_backend_election_event") {
                                setElectionEventIdFlag("");
                                setElectionIdFlag("");
                                navigate("/sequent_backend_election_event/" + parentData.id);
                            }
                            if ((parentData === null || parentData === void 0 ? void 0 : parentData.__typename) === "sequent_backend_election") {
                                setElectionIdFlag("");
                                setContestIdFlag("");
                                navigate("/sequent_backend_election/" + parentData.id);
                            }
                            if ((parentData === null || parentData === void 0 ? void 0 : parentData.__typename) === "sequent_backend_contest") {
                                setElectionIdFlag("");
                                setContestIdFlag("");
                                navigate("/sequent_backend_contest/" + parentData.id);
                            }
                        },
                        onError: function () {
                            setOpenDeleteModal(false);
                            notify(t("sideMenu.menuActions.messages.notification.error.delete"), {
                                type: "error",
                            });
                        },
                        onSettled: function () {
                            setSelectedActionModal(null);
                        },
                    });
                }
                return [2 /*return*/];
            });
        });
    }
    var openActionMenu = Boolean(anchorEl);
    var idActionMenu = openActionMenu ? "action-menu" : undefined;
    /**
     * Permissions
     */
    var _h = useActionPermissions(), canCreateElectionEvent = _h.canCreateElectionEvent, canDeleteElectionEvent = _h.canDeleteElectionEvent, canArchiveElectionEvent = _h.canArchiveElectionEvent, canCreateContest = _h.canCreateContest, canDeleteContest = _h.canDeleteContest, canCreateCandidate = _h.canCreateCandidate, canDeleteCandidate = _h.canDeleteCandidate, canCreateElection = _h.canCreateElection, canDeleteElection = _h.canDeleteElection;
    var canShowCreate = (resourceType === "sequent_backend_election_event" && canCreateElectionEvent) ||
        (resourceType === "sequent_backend_election" && canCreateElection) ||
        (resourceType === "sequent_backend_contest" && canCreateContest && canCreateElection) ||
        (resourceType === "sequent_backend_candidate" &&
            canCreateCandidate &&
            canCreateElection &&
            canCreateContest);
    var canShowDelete = (resourceType === "sequent_backend_election_event" && canDeleteElectionEvent) ||
        (resourceType === "sequent_backend_election" && canDeleteElection) ||
        (resourceType === "sequent_backend_contest" && canDeleteContest && canDeleteElection) ||
        (resourceType === "sequent_backend_candidate" &&
            canDeleteCandidate &&
            canDeleteElection &&
            canDeleteContest);
    /**
     * ======
     */
    /**
     * Create and import ee from drawer
     */
    var _j = useCreateElectionEventStore(), openCreateDrawer = _j.openCreateDrawer, openImportDrawer = _j.openImportDrawer;
    var handleOpenCreateElectionEventForm = function (e) {
        setAnchorEl(null);
        openCreateDrawer === null || openCreateDrawer === void 0 ? void 0 : openCreateDrawer();
    };
    var handleOpenImportElectionEventForm = function (e) {
        setAnchorEl(null);
        openImportDrawer === null || openImportDrawer === void 0 ? void 0 : openImportDrawer();
    };
    /**
     * ======
     */
    return (_jsxs(_Fragment, { children: [_jsx(StyledIconContainer, { onClick: handleOpenItemActions, children: ((!isArchivedTab && (canShowCreate || canShowDelete || canArchiveElectionEvent)) ||
                    (isArchivedTab && (canArchiveElectionEvent || canShowDelete))) && (_jsx(MoreHorizIcon, { id: "MoreHorizIcon" })) }), _jsx(Popover, { id: idActionMenu, open: openActionMenu, anchorEl: anchorEl, onClose: handleCloseActionMenu, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right",
                }, children: _jsxs(MenuList, { dense: true, children: [!isArchivedTab && canShowCreate && (_jsxs(MenuItem, { dir: i18n.dir(i18n.language), className: "menu-action-add-".concat(resourceType), onClick: function (e) {
                                if (resourceType === "sequent_backend_election_event") {
                                    handleOpenCreateElectionEventForm(e);
                                }
                                else {
                                    handleAction(Action.Add, {
                                        id: resourceId,
                                        name: resourceName,
                                        type: resourceType,
                                    });
                                }
                            }, children: [_jsx(ListItemIcon, { children: _jsx(StyledAddCircleIcon, {}) }), t(mapAddResource[resourceType])] }, Action.Add)), isItemElectionEventType &&
                            !isArchivedTab &&
                            canShowCreate &&
                            canShowDelete && _jsx(Divider, {}, "divider0"), !isArchivedTab &&
                            canShowCreate &&
                            resourceType === "sequent_backend_election_event" ? (_jsxs(MenuItem, { dir: i18n.dir(i18n.language), className: "menu-action-add-".concat(resourceType), onClick: handleOpenImportElectionEventForm, children: [_jsx(ListItemIcon, { children: _jsx(StyledAddCircleIcon, {}) }), t(mapImportResource[resourceType])] }, Action.Import)) : null, isItemElectionEventType &&
                            !isArchivedTab &&
                            canShowCreate &&
                            canShowDelete && _jsx(Divider, {}, "divider1"), isItemElectionEventType && canArchiveElectionEvent && (_jsxs(MenuItem, { dir: i18n.dir(i18n.language), className: "menu-action-archive-".concat(resourceType), onClick: function () {
                                return handleAction(isArchivedTab ? Action.Unarchive : Action.Archive, {
                                    id: resourceId,
                                    name: resourceName,
                                    type: resourceType,
                                });
                            }, children: [_jsx(ListItemIcon, { children: _jsx(InventoryIcon, { color: "error" }) }), isArchivedTab
                                    ? t("sideMenu.menuActions.unarchive.electionEvent")
                                    : t("sideMenu.menuActions.archive.electionEvent")] }, Action.Archive)), canArchiveElectionEvent && canShowCreate && canShowDelete && (_jsx(Divider, {}, "divider2")), canShowDelete && (_jsxs(MenuItem, { dir: i18n.dir(i18n.language), className: "menu-action-delete-".concat(resourceType), onClick: function () {
                                return handleAction(Action.Remove, {
                                    id: resourceId,
                                    name: resourceName,
                                    type: resourceType,
                                });
                            }, children: [_jsx(ListItemIcon, { children: _jsx(DeleteIcon, { color: "error" }) }), t(mapRemoveResource[resourceType])] }, Action.Remove))] }) }), _jsx(Dialog, { variant: "warning", open: openArchiveModal, ok: (selectedActionModal === null || selectedActionModal === void 0 ? void 0 : selectedActionModal.action) === Action.Archive
                    ? t("common.label.archive")
                    : t("common.label.unarchive"), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), handleClose: function (result) {
                    if (result) {
                        confirmArchiveAction();
                    }
                    setOpenArchiveModal(false);
                }, children: getMenuActionConfirmMessage(t, (selectedActionModal === null || selectedActionModal === void 0 ? void 0 : selectedActionModal.action) === Action.Archive ? "archive" : "unarchive", selectedActionModal === null || selectedActionModal === void 0 ? void 0 : selectedActionModal.payload.name) }), _jsx(Dialog, { variant: "warning", open: openDeleteModal, ok: String(t("common.label.delete")), cancel: String(t("common.label.cancel")), title: String(t("common.label.warning")), handleClose: function (result) {
                    if (result) {
                        confirmDeleteAction();
                    }
                    setOpenDeleteModal(false);
                }, children: getMenuActionConfirmMessage(t, "delete", selectedActionModal === null || selectedActionModal === void 0 ? void 0 : selectedActionModal.payload.name) })] }));
}
var templateObject_1, templateObject_2;
